import React from 'react';
import { SectionReveal } from '../components/SectionReveal';
import { StarIcon } from 'lucide-react';
function Stars() {
  return <div className="flex gap-1 mb-3" aria-label="5 estrellas" data-id="element-208">
      <StarIcon className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-209" />
      <StarIcon className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-210" />
      <StarIcon className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-211" />
      <StarIcon className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-212" />
      <StarIcon className="w-5 h-5 text-brand-gold fill-brand-gold" data-id="element-213" />
    </div>;
}
function Avatar({
  initials,
  color
}: {
  initials: string;
  color: string;
}) {
  return <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 font-heading font-bold text-white text-lg ${color}`} data-id="element-214">
      {initials}
    </div>;
}
export function TestimonialsSection() {
  return <section className="relative w-full bg-brand-darker py-20 md:py-28 overflow-hidden" data-id="element-215">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-gold/20 to-transparent" data-id="element-216" />

      <div className="relative z-10 max-w-5xl mx-auto px-4" data-id="element-217">
        <SectionReveal data-id="element-218">
          <p className="text-4xl mb-4 text-center" data-id="element-219">👥</p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl text-white text-center mb-4 uppercase" data-id="element-220">
            Miles de personas ya lo están aplicando para pagar menos.
          </h2>
          <p className="text-xl text-gray-400 font-body text-center mb-14" data-id="element-221">
            Porque el problema es el mismo en todas las casas.
          </p>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-222">
          {/* Testimonial 1 */}
          <SectionReveal delay={0.05} data-id="element-223">
            <div className="bg-brand-dark border border-gray-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-224">
              <Stars data-id="element-225" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-226">
                "No podía creer la diferencia. Mi factura bajó de $85.000 a
                $38.000 en un solo mes. La guía es súper clara y fácil de
                seguir."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-227">
                <Avatar initials="ML" color="bg-pink-600" data-id="element-228" />
                <div data-id="element-229">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-230">
                    María L.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-231">
                    42 años, Córdoba
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 2 */}
          <SectionReveal delay={0.1} data-id="element-232">
            <div className="bg-brand-dark border border-gray-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-233">
              <Stars data-id="element-234" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-235">
                "Siempre pensé que no había nada que hacer con la luz. Apliqué 3
                consejos de la guía y ya noté el cambio. Muy recomendable."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-236">
                <Avatar initials="CR" color="bg-blue-600" data-id="element-237" />
                <div data-id="element-238">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-239">
                    Carlos R.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-240">
                    38 años, Rosario
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 3 */}
          <SectionReveal delay={0.15} data-id="element-241">
            <div className="bg-brand-dark border border-gray-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-242">
              <Stars data-id="element-243" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-244">
                "Soy jubilada y cada peso cuenta. Esta guía me ayudó a detectar
                errores que venía arrastrando hace años. Ojalá la hubiera tenido
                antes."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-245">
                <Avatar initials="LG" color="bg-purple-600" data-id="element-246" />
                <div data-id="element-247">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-248">
                    Luciana G.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-249">
                    71 años, Buenos Aires
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 4 */}
          <SectionReveal delay={0.2} data-id="element-250">
            <div className="bg-brand-dark border border-gray-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-251">
              <Stars data-id="element-252" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-253">
                "Tengo un comercio y la luz me estaba matando. Con los ajustes
                que hice gracias a la guía, ahorro más de $50.000 por mes."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-254">
                <Avatar initials="FM" color="bg-emerald-600" data-id="element-255" />
                <div data-id="element-256">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-257">
                    Fernando M.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-258">
                    45 años, Mendoza
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>

          {/* Testimonial 5 */}
          <SectionReveal delay={0.25} data-id="element-259">
            <div className="bg-brand-dark border border-gray-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-260">
              <Stars data-id="element-261" />
              <p className="text-gray-300 font-body text-base leading-relaxed mb-5 flex-1 italic" data-id="element-262">
                "Lo mejor es que no necesitás saber nada técnico. Todo está
                explicado paso a paso. En mi casa ya se nota la diferencia."
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-gray-700/50" data-id="element-263">
                <Avatar initials="AP" color="bg-orange-600" data-id="element-264" />
                <div data-id="element-265">
                  <p className="text-white font-body font-semibold text-sm m-0" data-id="element-266">
                    Andrea P.
                  </p>
                  <p className="text-gray-500 font-body text-xs m-0" data-id="element-267">
                    35 años, Tucumán
                  </p>
                </div>
              </div>
            </div>
          </SectionReveal>
        </div>
      </div>
    </section>;
}